// Styles
import "../styles/AdminAuth.css";
// Components
import LeftPanel from "../components/auth/adminAuthComponents/LeftPanel";
import AdminForm from "../components/auth/adminAuthComponents/AdminForm";

function AdminAuthPage() {
  return (
    <section className="adminAuth">
      <div className="adminAuth__card">
        {/* LEFT PANEL — image and stats */}
        <LeftPanel />

        {/* RIGHT PANEL — login form */}
        <AdminForm />
      </div>
    </section>
  );
}

export default AdminAuthPage;
